export default [
    { title: "Disable async interceptor for calls to CM connector", key: "disable-async", anon: true },
    { title: "New add connector", key: "newAddConnector" },
    { title: "Always show relationship lines", key: "relationships-always-on" },
    { title: "Hide S3 Cloud from Canvas", key: "hide-s3" },
    { title: "Notifications", key: "notifications" },
    { title: "Demo Mode", key: "demo-mode", anon: true },
    { title: "System Manager for OnPrem", key: "systemManagerOnPrem" }
];
